import { Component } from 'react';
import { DynamicDefaultProps, composeDefaultProps } from '@synergy/utils';

export interface DynamicDefaultState<Props> {
    defaultProps: Partial<Props>;
}

export abstract class PoolDynamicDefaultPropsComponent<
    Props = Record<string, never>,
    State extends DynamicDefaultState<Props> = {
        defaultProps: Partial<Props>;
    }
> extends Component<Props, State> {
    // Default state has to be a subset of the generic type state
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public override state: any = {
        defaultProps: {},
    };

    protected dynamicDefaultProps: DynamicDefaultProps<Props> = {};
    // Default propKey cannot be typed correctly because props is generic
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    protected defaultPropKey: keyof Props = 'styleType' as any;

    public override componentDidMount() {
        this.setState({
            defaultProps: composeDefaultProps(
                this.props,
                // Dirty fix because this was broken after  typescript update (wrong types).
                // We should get rid of the default props anyway
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                this.defaultPropKey as any,
                this.dynamicDefaultProps
            ) as Partial<Props>,
        });
    }
}
